import React from 'react';
import {
    Select as AntdSelect,
    type SelectProps as AntdSelectProps,
    type RefSelectProps,
} from 'antd';
import type {
    BaseOptionType,
    DefaultOptionType,
} from 'antd/es/select';

export type SelectProps<
    ValueType = unknown,
    OptionType extends BaseOptionType | DefaultOptionType = DefaultOptionType,
> = AntdSelectProps<ValueType, OptionType>;

type SelectComponent = (<
    ValueType = unknown,
    OptionType extends BaseOptionType | DefaultOptionType = DefaultOptionType,
>(
    props: React.PropsWithChildren<SelectProps<ValueType, OptionType>> &
        React.RefAttributes<RefSelectProps>,
) => React.ReactElement) & {
    displayName?: string;
    Option: typeof AntdSelect.Option;
    OptGroup: typeof AntdSelect.OptGroup;
};

const SelectRender = (
    props: AntdSelectProps,
    ref: React.Ref<RefSelectProps>,
) => <AntdSelect ref={ref} {...props} />;

const Select = React.forwardRef<RefSelectProps, AntdSelectProps>(
    SelectRender,
) as unknown as SelectComponent;

Select.displayName = 'Select';
Select.Option = (AntdSelect as typeof AntdSelect | undefined)
    ?.Option as typeof AntdSelect.Option;
Select.OptGroup = (AntdSelect as typeof AntdSelect | undefined)
    ?.OptGroup as typeof AntdSelect.OptGroup;

export { AntdSelect };
export type { RefSelectProps, BaseOptionType, DefaultOptionType };
export default Select;
